<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'primevue/usetoast'
import axiosInstance from '@/plugins/axios'

const router = useRouter()
const toast = useToast()
const email = ref('')
const loading = ref(false)
const submitted = ref(false)

const submit = async () => {
  if (!email.value) return
  loading.value = true
  try {
    await axiosInstance.post('/auth/forgot-password', { email: email.value })
    submitted.value = true
  } catch (error: any) {
    toast.add({ severity: 'error', summary: 'Fehler', detail: error.toString(), life: 5000 })
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="vh-100 d-flex align-items-center justify-content-center">
    <div class="surface-card p-5 shadow-2 border-round" style="max-width: 500px; min-width: 350px">
      <ProgressBar v-if="loading" mode="indeterminate" class="mb-5" style="height: 6px" />

      <div class="text-center mb-5">
        <div class="text-900 text-3xl font-medium mb-1">Reset Password</div>
        <div class="text-sm font-medium mb-1">AIRiN Admin-Center</div>
      </div>

      <div v-if="!submitted">
        <p class="text-600 mb-4">
          Enter your email address. You will receive a link to reset your password.
        </p>

        <label for="email" class="block text-900 font-medium mb-2">Email</label>
        <InputText
          id="email"
          type="email"
          v-model="email"
          class="w-full mb-4"
          @keyup.enter="submit"
        />

        <Button
          label="Send Reset Link"
          icon="pi pi-envelope"
          class="w-full mb-3"
          :loading="loading"
          @click="submit"
        />
      </div>

      <div v-else class="text-center">
        <i class="pi pi-check-circle text-green-500 mb-3" style="font-size: 3rem" />
        <p class="text-700 mb-4">
          If an account with that email exists, a password reset link has been sent. Please check
          your inbox.
        </p>
      </div>

      <div class="text-center mt-2">
        <a class="font-medium text-blue-500 cursor-pointer" @click="router.push('/login')">
          Back to Login
        </a>
      </div>
    </div>
  </div>
  <div class="background-overlay" />
</template>

<style scoped>
.vh-100 {
  height: 100vh;
}
.d-flex {
  display: flex;
}
.align-items-center {
  align-items: center;
}
.justify-content-center {
  justify-content: center;
}

.background-overlay {
  width: 100%;
  height: 100%;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 1;
  background: black !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
}

.surface-card {
  background-color: white !important;
  color: var(--tuev-dark-blue);
  z-index: 2;
}

.p-button {
  background-color: var(--tuev-light-blue);
  border-color: var(--tuev-light-blue);
}

.p-button:hover {
  background-color: var(--tuev-dark-blue) !important;
  border-color: var(--tuev-dark-blue) !important;
}
</style>
